export const HAS_SEEN_ADD_TO_CALENDAR_PROMO_STORAGE_KEY = 'has_seen_add_to_calendar_promo';
